import { Controller } from "@hotwired/stimulus";

// The order of a report card's blocks in the studio: dragged, or moved with the
// arrows for the keyboard. The hidden fields the rows hold go with them.
export default class extends Controller {
  static targets = ["row"];

  up(event) {
    const row = this.rowOf(event);
    if (row.previousElementSibling) this.place(row, row.previousElementSibling);
  }

  down(event) {
    const row = this.rowOf(event);
    if (row.nextElementSibling) this.place(row.nextElementSibling, row);
  }

  start(event) {
    this.dragged = this.rowOf(event);
    event.dataTransfer.effectAllowed = "move";
  }

  over(event) {
    event.preventDefault();
  }

  drop(event) {
    event.preventDefault();
    const row = this.rowOf(event);
    if (!this.dragged || row === this.dragged) return;

    const after = this.rowTargets.indexOf(row) > this.rowTargets.indexOf(this.dragged);
    this.place(this.dragged, after ? row.nextElementSibling : row);
    this.dragged = null;
  }

  // private

  rowOf(event) {
    return event.currentTarget.closest("[data-block-order-target='row']");
  }

  place(row, before) {
    row.parentNode.insertBefore(row, before);
    this.dispatch("moved");
  }
}
